import { render, staticRenderFns } from "./STable.vue?vue&type=template&id=da68046e&scoped=true&"
import script from "./STable.vue?vue&type=script&lang=js&"
export * from "./STable.vue?vue&type=script&lang=js&"
import style0 from "./STable.vue?vue&type=style&index=0&id=da68046e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da68046e",
  null
  
)

export default component.exports